// Bot lines shared by the step catalog (thread history) and the chat turns
// that ask them.
export const chatCopy = {
  cnp: ["Pentru a te identifica, am nevoie de CNP-ul tău."],
  email: [
    "Ce adresă de email ai?",
    "Îți trimitem documente importante și, cu acordul tău, oferte personalizate.",
  ],
  emailCode: [
    "În câteva secunde vei primi un email cu un cod de verificare.",
    "Te rugăm să introduci acel cod aici",
  ],
  emailCodeResent: ["Ți-am trimis un cod nou pe email."],
  income: ["Ce venit net lunar ai?", "Introdu venitul lunar, după taxe."],
  bcConsent: [
    "Pentru oferta preliminară, trebuie să facem o verificare la Biroul de Credit, fără impact asupra scorului tău.",
    "Ești de acord să îți verificăm datele la Biroul de Credit și ANAF?",
  ],
  consentWhy: [
    "La Biroul de Credit vedem istoricul tău de credite, iar la ANAF confirmăm venitul. Fără ele nu îți putem calcula o ofertă.",
    "Verificarea nu îți afectează scorul de credit.",
  ],
  terms: [
    "Pentru oferta ta, trebuie să facem o verificare la Biroul de Credit, fără impact asupra scorului tău.",
    "Ești de acord să îți verificăm datele la Biroul de Credit și ANAF?",
  ],
  anafConsent: [
    "Ca să îți calculăm oferta finală, confirmăm venitul tău la ANAF.",
    "Ești de acord să îți verificăm datele la ANAF?",
  ],
  bcChecking: ["Verificarea durează câteva secunde..."],
  bcPhones: [
    "Am descoperit câteva numere de telefon asociate CNP-ului tău înregistrate la Biroul de Credit.",
    "Pe care dintre ele vrei să primești un SMS de verificare?",
  ],
  bcNoPhones: [
    "Nu am găsit numere de telefon asociate CNP-ului tău la Biroul de Credit.",
    "Putem continua cu verificarea identității.",
  ],
  bcCode: [
    "În câteva secunde vei primi un SMS cu un cod de verificare de la Biroul de Credit.",
    "Te rugăm să introduci acel cod aici pentru a verifica că acel număr îți aparține",
  ],
  bcCodeResent: ["Ți-am trimis un cod nou prin SMS."],
  bcKycNeeded: [
    "Pentru verificare avem nevoie mai întâi să îți confirmăm identitatea.",
  ],
  bcFailed: [
    "Nu am putut verifica istoricul tău. Întâmpinăm o problemă tehnică la Biroul de Credit.",
  ],
  offerRenewal: [
    "Bine ai revenit! 👋",
    "A trecut ceva timp de la ultima verificare. Hai să-ți actualizăm oferta.",
  ],
  welcomeQuestions: [
    "Îți cer venitul net lunar, adresa de email și CNP-ul.",
    "Apoi, cu acordul tău, îți verificăm datele la Biroul de Credit, fără impact asupra scorului tău.",
  ],
  welcomeStart: "Da, hai să începem",
  preliminaryPreparing: ["Pregătim oferta ta preliminară..."],
  preliminaryOffersTitle: "Ofertele tale preliminare ✨",
  preliminaryFailed: [
    "Nu am putut calcula oferta din cauza unei probleme tehnice. Te rugăm să încerci din nou.",
  ],
} as const;

// The greeting before the first question, by name once the backend knows it.
export const getWelcomeLines = (firstName?: string | null) => [
  `Bună${firstName ? ` ${firstName}` : ""}, eu sunt Volt AI, asistentul tău financiar personal.`,
  "Te pot ajuta să iei cel mai potrivit credit pentru tine.",
  "Ești dispus să răspunzi la câteva întrebări?",
];

export const formatIncome = (income: number) => `${income} lei`;

// Shows enough of the CNP to recognise it without exposing it on screen.
export const maskCnp = (cnp: string) =>
  cnp.length > 6
    ? `${cnp.slice(0, 3)}${"•".repeat(cnp.length - 6)}${cnp.slice(-3)}`
    : cnp;
